const BaseComponent = require('base/base-component');

class pageFooter extends BaseComponent {
  init () {
    const multipleWeb = [{
      name: '中国政府采购网',
      url: 'http://www.ccgp.gov.cn'
    }, {
      name: '广西壮族自治区财政厅',
      url: 'http://www.gxcz.gov.cn'
    }];
    const cityWeb = [{
      name: '余杭政府采购',
      url: 'http://www.yhggzy.com.cn'
    },
    {
      name: '嘉善政府采购',
      url: 'http://www.jszbw.com/web/index.jsp'
    },
    {
      name: '平湖政府采购',
      url: 'http://ztb.pinghu.gov.cn/phcms'
    },
    {
      name: '海盐政府采购',
      url: ' http://www.hyztb.gov.cn/web/index.jsp'
    },
    {
      name: '萧山政府采购',
      url: 'http://www.xszbjyw.com/index.aspx'
    },
    {
      name: '桐庐政府采购',
      url: 'http://www.tlztb.com'
    },
    {
      name: '富阳政府采购',
      url: 'http://www.hzfyggzy.org.cn'
    },
    {
      name: '东阳政府采购',
      url: 'http://www.dyzfcgw.gov.cn'
    },
    {
      name: '上虞政府采购',
      url: 'http://www.syztb.gov.cn/syqztb/default.aspx'
    },
    {
      name: '瑞安政府采购',
      url: 'http://www.raztb.com/'
    }
    ];
    const provinceWeb = [{
      name: '北京政府采购',
      url: 'http://www.ccgp-beijing.gov.cn'
    },
    {
      name: '天津政府采购',
      url: 'http://www.ccgp-tianjin.gov.cn'
    },
    {
      name: '河南政府采购',
      url: 'http://www.ccgp-henan.gov.cn'
    },
    {
      name: '河北政府采购',
      url: 'http://www.ccgp-hebei.gov.cn/zfcg'
    },
    {
      name: '湖北政府采购',
      url: 'http://www.ccgp-hubei.gov.cn'
    },
    {
      name: '湖南政府采购',
      url: 'http://www.ccgp-hunan.gov.cn'
    },
    {
      name: '山西政府采购',
      url: 'http://www.ccgp-shanxi.gov.cn/default.html'
    },
    {
      name: '山东政府采购',
      url: 'http://www.ccgp-shandong.gov.cn/sdgp2014/site/index.jsp'
    },
    {
      name: '黑龙江政府采购',
      url: 'http://www.ccgp-heilongj.gov.cn'
    },
    {
      name: '吉林省政府采购',
      url: 'http://www.ccgp-jilin.gov.cn'
    },
    {
      name: '辽宁省政府采购',
      url: 'http://www.ccgp-liaoning.gov.cn'
    },
    {
      name: '广东省政府采购',
      url: 'http://www.ccgp-guangdong.gov.cn'
    },
    {
      name: '海南省政府采购',
      url: 'http://www.ccgp-hainan.gov.cn'
    },
    {
      name: '内蒙古政府采购',
      url: 'http://www.ccgp-neimenggu.gov.cn'
    },
    {
      name: '陕西政府采购',
      url: 'http://www.ccgp-shaanxi.gov.cn'
    },
    {
      name: '甘肃政府采购',
      url: 'http://www.ccgp-gansu.gov.cn'
    },
    {
      name: '青海政府采购',
      url: 'http://www.ccgp-qinghai.gov.cn'
    },
    {
      name: '宁夏政府采购',
      url: 'http://www.ccgp-ningxia.gov.cn'
    },
    {
      name: '江西政府采购',
      url: 'http://www.ccgp-jiangxi.gov.cn'
    },
    {
      name: '新疆政府采购',
      url: 'http://www.ccgp-xinjiang.gov.cn'
    },
    {
      name: '西藏政府采购',
      url: 'http://www.ccgp-xizang.gov.cn'
    },
    {
      name: '四川政府采购',
      url: 'http://www.ccgp-sichuan.gov.cn'
    },
    {
      name: '江苏政府采购',
      url: 'http://www.ccgp-jiangsu.gov.cn'
    },
    {
      name: '广西政府采购',
      url: 'http://www.ccgp-guangxi.gov.cn'
    },
    {
      name: '云南政府采购',
      url: ' http://www.ccgp-yunnan.gov.cn'
    },
    {
      name: '福建政府采购',
      url: 'http://cz.fjzfcg.gov.cn'
    },
    {
      name: '安徽政府采购',
      url: 'http://www.ccgp-anhui.gov.cn'
    },
    {
      name: '贵州政府采购',
      url: 'http://www.ccgp-guizhou.gov.cn'
    },
    {
      name: '重庆政府采购',
      url: 'http://www.ccgp-chongqing.gov.cn'
    }
    ];
    const webArr = [provinceWeb, multipleWeb];
    const lis = this.$el.find('.footer-header-first-ul>li');
    if (lis.length > 0) {
      $.each(lis, (index, item) => {
        const web = webArr[index];
        let htmlTemp = '<div  class=\'webList\'><ul>';
        for (let i = 0; i < web.length; i++) {
          htmlTemp += '<li><a href=' + web[i].url + ' target=\'_blank\'>' + web[i].name + '</a></li>';
        }
        htmlTemp += '</ul></div>';
        $(item).append($(htmlTemp));
      });
    }
  }
}
module.exports = pageFooter;
